import { useEffect, useState } from 'react'

import Api from 'services/api'

const useCriticalAndMajorAlerts = (options = {}) => {
  const [criticalAndMajorAlerts, setCriticalAndMajorAlerts] = useState(null)
  const [criticalAndMajorAlertsMetaData, setCriticalAndMajorAlertsMetaData] = useState(null)
  const [areCriticalAndMajorAlertsLoaded, setAreCriticalAndMajorAlertsLoaded] = useState(null)

  useEffect(() => {
    setCriticalAndMajorAlerts(null)
    setCriticalAndMajorAlertsMetaData(null)
    setAreCriticalAndMajorAlertsLoaded(false)

    Api.AlertNotifications.list(options)
      .then((res) => {
        const { items, ...metadata } = res
        setCriticalAndMajorAlerts(items)
        setCriticalAndMajorAlertsMetaData(metadata)
        setAreCriticalAndMajorAlertsLoaded(true)
      }).catch(() => {
        setCriticalAndMajorAlerts(null)
        setCriticalAndMajorAlertsMetaData(null)
        setAreCriticalAndMajorAlertsLoaded(true)
      })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [options.sortAttribute, options.sortDirection, options.page, options.query])

  return { criticalAndMajorAlerts, areCriticalAndMajorAlertsLoaded, criticalAndMajorAlertsMetaData }
}

export default useCriticalAndMajorAlerts
